class StyledVariables {
  // Colors
  static colors = {
    primary: "#115f37",
    black: "#333333",
    white: "#ffffff",
    yellow: "#fcdb5a",
    brow: "#666666",
    red: "#d9363e",
  };

  // Font Size
  static fontSize = {
    fontS: 12,
    fontM: 16,
    fontMP: 20,
    fontL: 24,
    fontXL: 36,
    fontXXL: 56,
  };

  // Font weight
  static fontWeight = {
    light: 300,
    regular: 400,
    semiBold: 600,
    bold: 900,
  };

  // Spacing
  static spacing = {
    sp4: 4,
    sp8: 8,
    sp12: 12,
    sp16: 16,
    sp20: 20,
    sp24: 24,
    sp28: 28,
    sp30: 30,
    sp32: 32,
    sp36: 36,
    sp40: 40,
    sp44: 44,
    sp48: 48,
    sp52: 52,
    sp56: 56,
    sp60: 60,
    sp80: 80,
    sp96: 96,
    sp112: 112,

    // Grid Spacing
    gap1: 1,
    gap2: 2,
    gap3: 3,
    gap4: 4,
    gap5: 5,
    gap6: 6,
    gap7: 7,
    gap8: 8,
    gap9: 9,
    gap10: 10,
    gap11: 11,
    gap12: 12,
  };
}

export default StyledVariables;
